module.exports = __webpack_public_path__ + "static/media/chocolates-candy.c947a9a3.png";